export default "__VITE_ASSET__CqyVmQR9__"